module.exports = __webpack_public_path__ + "static/media/WhatwedoImg2.ee9c8ec3.png";